// eslint-disable-next-line import/prefer-default-export
export const closeButtonId = 'info-tooltip-close-btn';
